import {useGetAndSet} from "./useGetAndSet";
import {createSetRentalMarginDataAction} from "../actions/dataActions";

export const useRentalMarginData = (params, dataFresh, nofetch) => {
    return useGetAndSet("rentalmargin", params, createSetRentalMarginDataAction, dataFresh, nofetch)
}